/** Auto-generated at build/start - do not edit */
export const BUILD_VERSION = "0.4.0";
